import React from "react";
import { Button, Modal, notification } from "tea-component";
import { useIntl } from "umi";
import { deletePersonalData } from "../service";

interface IDeleteModalProps {
  gameCode: string;
  deleteInfo: IDeleteInfo;
  setDeleteInfo: (info: IDeleteInfo) => void;
  deleteCallBack?: () => void;
}

interface IDeleteInfo {
  visible: boolean;
  record: IDeleteRecord;
}

interface IDeleteRecord {
  charts: any[];
  table_id: string;
  table_name: string;
  [key: string]: any;
}

export default function DeleteModal(props: IDeleteModalProps) {
  const { gameCode, deleteInfo, setDeleteInfo, deleteCallBack } = props || {};
  const { visible, record } = deleteInfo || {};
  const { charts, table_id: tableId, table_name: tableName } = record || {};
  const isWarning = charts?.length > 0;
  const { formatMessage } = useIntl();

  const deletedFunc = () => {
    const params = {
      game_code: gameCode,
      table_id: tableId,
    };
    deletePersonalData(params).then(() => {
      deleteCallBack?.();
      notification.success({
        description: formatMessage({ id: "dbl_sql_view_delete_success" }),
        duration: 3000
      });
    }).catch((e) => {
      notification.error({
        description: formatMessage({ id: "dbl_sql_view_delete_fail" }, { code: e?.code }),
        duration: 3000
      });
    });
  };

  if (!visible) return null;

  return (
    isWarning ? <Modal
      visible={visible}
      onClose={() => {
        setDeleteInfo({ visible: false, record: { charts: [], table_id: '', table_name: '' } });
      }}
    >
      <Modal.Body className="modal-context" style={{ marginLeft: 0, marginRight: '40px' }}>
        <Modal.Message
          icon="error"
          message={<span className="dbl_text-strong">{formatMessage({ id: "dbl_personal_data_delete_title" })}</span>}
          description={formatMessage({ id: "dbl_sql_view_warning_to_delete_message" }, { name: <span className="dbl_text-strong">{tableName}</span>, number: charts?.length })}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            setDeleteInfo({ visible: false, record: { charts: [], table_id: '', table_name: '' } });
          }}
        >
          {formatMessage({ id: "dbl_sql_view_i_know" })}
        </Button>
      </Modal.Footer>
    </Modal> :
      <Modal
        visible={visible}
        onClose={() => {
          setDeleteInfo({ visible: false, record: { charts: [], table_id: '', table_name: '' } });
        }}
      >
        <Modal.Body className="modal-context">
          <Modal.Message
            message={<span className="dbl_text-strong">{formatMessage({ id: "dbl_personal_data_delete_title" })}</span>}
            description={formatMessage({ id: "dbl_sql_view_sure_to_delete_message" })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setDeleteInfo({ visible: false, record: { charts: [], table_id: '', table_name: '' } });
              deletedFunc();
            }}
          >
            {formatMessage({ id: "dbl_common_confirm" })}
          </Button>
          <Button
            type="weak"
            onClick={() => {
              setDeleteInfo({ visible: false, record: { charts: [], table_id: '', table_name: '' } });
            }}
          >
            {formatMessage({ id: "dbl_common_cancel" })}
          </Button>
        </Modal.Footer>
      </Modal>
  );
}